export const NULL_UUID_ID = '00000000-0000-0000-0000-000000000000'

export const MAX_PRIORITY = 2147483647

export const DEFAULT_SUPPLIER = 'pipssupplier'

export const PREVIEW_DATA_COLUMN_MAPPING_LABELS: { [x: string]: string } = {
  articleColumnNumber: 'Артикул',
  articleInchColumnNumber: 'Артикул (поставщика)',
  descriptionColumnNumber: 'Наименование',
  brandColumnNumber: 'Бренд',
  itemLengthColumnNumber: 'Длина',
  itemWidthColumnNumber: 'Ширина',
  itemHeightColumnNumber: 'Высота',
  itemWeightColumnNumber: 'Вес',
  unitOfMeasurementColumnNumber: 'Единица измерения',
  detailsColumnNumber: 'Описание',
  warrantyColumnNumber: 'Гарантия',
  commentColumnNumber: 'Комментарий',
  countryOfOriginColumnNumber: 'Страна происхождения',
  categoryColumnNumber: 'Категория',
  barcodeColumnNumber: 'Штрихкод',
  multiplicityColumnNumber: 'Кратность',
  // Price list specific
  priceColumnNumber: 'Цена',
  stockColumnNumber: 'Наличие',
  supplierCodeColumnNumber: 'Код поставщика',
  groupColumnNumber: 'Группа',
  minPriceColumnNumber: 'Мин. цена',
}
